import { Alert, Platform } from "react-native";
import { captureException } from "@utils/captureException";
import * as Intercom from "@utils/intercom";

const SUPPORT_FALLBACK_MESSAGE =
  "Could not open the support chat. Please try again later.";

const showSupportFallback = () => {
  if (Platform.OS === "web") {
    window.alert(SUPPORT_FALLBACK_MESSAGE);
    return;
  }

  Alert.alert("Could not open support", SUPPORT_FALLBACK_MESSAGE);
};

export const presentIntercomSupport = async (operation: string) => {
  try {
    await Intercom.present();
  } catch (error) {
    if (Platform.OS === "web") {
      captureException(error, {
        channel: "error",
        area: "support",
        operation,
        fingerprint: ["intercom-present-failed", operation],
      });
    }
    showSupportFallback();
  }
};
